import {match} from 'ts-pattern';

import {isNil} from 'ramda';

import {
  FINANCING_ENDING_SKIP_REASON,
  FINANCING_ENDING_SKIP_REASON_BY_CODE,
  type FinancingEndingSkipReasonCode,
} from '@dms/api/sales';
import i18n from '@dms/i18n';

export const getFinancingEndingReasonLabel = (code: FinancingEndingSkipReasonCode | null) =>
  match(isNil(code) ? null : FINANCING_ENDING_SKIP_REASON_BY_CODE[code])
    .with(FINANCING_ENDING_SKIP_REASON.ORDER_REVIEW, () =>
      i18n.t('entity.businessCase.financingEnding.reason.orderReview')
    )
    .with(FINANCING_ENDING_SKIP_REASON.MULTIPLE_OPERATORS, () =>
      i18n.t('entity.businessCase.financingEnding.reason.multipleOperators')
    )
    .with(FINANCING_ENDING_SKIP_REASON.FINANCING_INSTITUTION, () =>
      i18n.t('entity.businessCase.financingEnding.reason.financingInstitution')
    )
    .with(FINANCING_ENDING_SKIP_REASON.CONTACT_UNAVAILABLE, () =>
      i18n.t('entity.businessCase.financingEnding.reason.contactUnavailable')
    )
    .with(FINANCING_ENDING_SKIP_REASON.CONSENT_REFUSED, () =>
      i18n.t('entity.businessCase.financingEnding.reason.consentRefused')
    )
    .with(FINANCING_ENDING_SKIP_REASON.MISSING_EMAIL, () =>
      i18n.t('entity.businessCase.financingEnding.reason.missingEmail')
    )
    .with(FINANCING_ENDING_SKIP_REASON.NOT_FOUND, () =>
      i18n.t('entity.businessCase.financingEnding.reason.notFound')
    )
    .with(FINANCING_ENDING_SKIP_REASON.MAILBOX_UNUSABLE, () =>
      i18n.t('entity.businessCase.financingEnding.reason.mailboxUnusable')
    )
    .with(FINANCING_ENDING_SKIP_REASON.TEMPLATE_UNUSABLE, () =>
      i18n.t('entity.businessCase.financingEnding.reason.templateUnusable')
    )
    .with(FINANCING_ENDING_SKIP_REASON.ATTACHMENT_UNUSABLE, () =>
      i18n.t('entity.businessCase.financingEnding.reason.attachmentUnusable')
    )
    .with(FINANCING_ENDING_SKIP_REASON.INCLUDED_IN_OTHER_SENDING, () =>
      i18n.t('entity.businessCase.financingEnding.reason.includedInOtherSending')
    )
    .otherwise(() => i18n.t('entity.businessCase.financingEnding.reason.unknown'));
